module.exports = __webpack_public_path__ + "img/search.c7f417c6.svg";